
import React, {useEffect, useState} from 'react';
import {map, isFunction} from 'lodash';
import {RadioButtonGroup, RadioButton} from '@sabre/spark-react-core/radio-button';


const RadioButtons = ({radioButtonsConfig}) => {
    const [selectedValue, setSelectedValue] = useState(radioButtonsConfig.selectedValue);

    const onGroupChange = (radioButtonValue, event) => {
        setSelectedValue(radioButtonValue);
        if(isFunction(radioButtonsConfig.onChangeHandler)) {
            radioButtonsConfig.onChangeHandler(radioButtonValue, event)
        }
    };

    return <RadioButtonGroup
            key={radioButtonsConfig.radioButtonName}
            name={radioButtonsConfig.radioButtonName}
            className={`row radio-buttons-container${radioButtonsConfig.radioButtonsClassName ? ` ${radioButtonsConfig.radioButtonsClassName}` : ''}`}
            value={selectedValue}
            onChange={onGroupChange}
        >
            <div className={radioButtonsConfig.titleClassName}>{radioButtonsConfig.title}:</div>
            {map(radioButtonsConfig.radioButtons, radioButton => <RadioButton
                key={`${radioButton.radioButtonName}-${radioButton.radioButtonValue}`}
                label={radioButton.radioButtonLabel}
                value={radioButton.radioButtonValue}
                className={`radio-button${radioButtonsConfig.radioButtonClassName ? ` ${radioButtonsConfig.radioButtonClassName}` : ''}`}
                disabled={radioButton.disabled}
            />)}
        </RadioButtonGroup>;
};

RadioButtons.propTypes = {

};

export default RadioButtons;
